import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfcsaf } from "./zfc_search_filter";
import { zfcsc } from "./zfc_shopping_cart";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
const FileSaver = require("file-saver");
export class zfcpc {
    static hasTargets() {
        return ($(".zfcpc-load-json").length > 0 ||
            $(".zfcpc-panel").length > 0 ||
            $(".zfcpd-mediapage-content").length > 0);
    }
    static bindCheckboxClick(e) {
        e.preventDefault();
        var that = $(this);
        var checkboxName = that.find("input").attr("name");
        var content = that.closest("[data-uid]");
        var allCheckboxes;
        if (content[0].className == "zfcpd-mediapage-content" ||
            that.closest(".zfcsaf-search-filter-wrapper").length) {
            allCheckboxes = content.find('input[name="' + checkboxName + '"]');
        }
        else {
            var cloneClass = that.closest(".slick-slide").data("clone-class"), currentWrapper = that.closest(".zfcpc-wrapper"), allCheckboxes = currentWrapper
                .find('[data-clone-class="' + cloneClass + '"]')
                .find('input[name="' + checkboxName + '"]');
        }
        if (allCheckboxes.attr("checked"))
            allCheckboxes.attr("checked", 0);
        else
            allCheckboxes.attr("checked", 1);
    }
    static downloadImages(e) {
        var that = $(this);
        if (that.attr("href") == undefined ||
            (!that.attr("href").endsWith("zip") && !that.attr("href").endsWith("pdf"))) {
            e.preventDefault();
            var g = 0;
            var checkedImageResolutions = $(this)
                .closest(".zfcui-btn-wrapper")
                .parent()
                .siblings(".zfcpc-dl-checkboxes")
                .find("input:checked");
            if (checkedImageResolutions.length == 0)
                return;
            zfUtils.displaySpinner();
            if (checkedImageResolutions.length == 1)
                FileSaver.saveAs(checkedImageResolutions.data("url"));
            zfUtils.hideSpinner();
        }
    }
    static downloadPress(id) {
        id = id.includes("_press_pressData")
            ? id
            : id.replace("_pressData", "_press_pressData");
        zfUtils.displaySpinner();
        $.ajax({
            url: "/api/solr/getSearch?query=matchall&language=" +
                document.querySelector("html").lang.toUpperCase() +
                "&filterValues= id:" +
                id +
                "&scope=press&queryType=press",
            dataType: "json",
            cache: false,
        })
            .done(function (json_data_tmp) {
            var json_data = json_data_tmp.body;
            var filesArr = [];
            var textLinks = "";
            if (json_data.hits.hit.length == 0) {
                zfUtils.hideSpinner();
                return;
            }
            json_data.hits.hit[0].files.forEach(function (file) {
                if (file.indexOf("http") != -1)
                    filesArr.push(file);
                else
                    textLinks += "https://zf.com/kaltura/" + file + "\n";
            });
            if (textLinks != "")
                filesArr.push(textLinks);
            if (filesArr.length)
                zfc.createZip(id.split(".")[1] + ".zip", filesArr, "videos");
            zfUtils.hideSpinner();
        })
            .fail(function (e) {
            window.alert("Error loading data...  status: " + e.status);
            zfUtils.hideSpinner();
        });
    }
    static addToStorage(item) {
        if ("localStorage" in window) {
            var thisPanel = item.closest(".zfcpc-panel"), uid = thisPanel.data("uid"), fsid = thisPanel.data("fsid"), panelData = {
                uid: uid,
                fsid: fsid,
                title: thisPanel.find(".zfcpc-panel-text").text().trim(),
                thumbnail: thisPanel
                    .find(".zfcpc-panel-heading img")
                    .attr("src")
                    .trim(),
                category: thisPanel.find(".zfcpc-panel-category").text().trim(),
                url: thisPanel.find(".zfcpc-panel-href").attr("href").trim(),
                zipUrl: thisPanel.find(".zfcpc-download-link").attr("href"),
                inBasket: true,
            };
            if (panelData.fsid.indexOf("pressData.media") != -1) {
                var checkedImageResolutions = $(item)
                    .closest(".zfcui-btn-wrapper")
                    .parent()
                    .siblings(".zfcpc-dl-checkboxes")
                    .find("input:checked");
                checkedImageResolutions.each(function () {
                    panelData.zipUrl = $(this).data("url");
                    if (panelData.zipUrl != "") {
                        var input = this;
                        panelData.fsid = fsid + "-" + input.defaultValue;
                        zfcpc.cartItems[uid] = JSON.stringify(panelData);
                        localStorage.setItem(uid + "-" + input.defaultValue, zfcpc.cartItems[uid]);
                        zfcsc.reloadCart();
                    }
                });
            }
            else {
                zfcpc.cartItems[uid] = JSON.stringify(panelData);
                localStorage.setItem(uid, zfcpc.cartItems[uid]);
                zfcsc.reloadCart();
            }
        }
        else {
            console.log("no localStorage in window");
        }
    }
    static removeFromStorage(item) {
        if ("localStorage" in window) {
            var thisPanel = item.closest(".zfcpc-panel"), uid = thisPanel.data("uid");
            $.each(localStorage, function (key, value) {
                if (key.startsWith(uid)) {
                    localStorage.removeItem(key);
                }
            });
            zfcsc.reloadCart();
        }
        else {
            console.log("no localStorage in window");
        }
    }
    static toggleCollectBtn(e) {
        e.preventDefault();
        var that = $(e.currentTarget);
        that.find(".zfcui-icon-cart-add").toggleClass("zfcui-icon-cart-remove");
        var content = that.closest("[data-uid]");
        var uid = content.attr("data-uid");
        var inStorage = zfcpc.isInLocalStorage(uid);
        if (!inStorage) {
            var fsid = uid.split("cart_link_").length > 1
                ? uid.split("cart_link_")[1]
                : "0000";
            var data = {
                uid: uid,
                fsid: fsid,
                title: $(".zfcpd-subline-text").text().trim(),
                category: $(".zfcpd-headline h2").text().trim(),
                inBasket: true,
            };
            if (content[0].className == "zfcpd-mediapage-content") {
                data.zipUrl = content.attr("data-image-high");
                data.thumbnail = data.zipUrl;
                data.fsid = fsid;
                zfcpc.cartItems[uid] = JSON.stringify(data);
                localStorage.setItem(uid, zfcpc.cartItems[uid]);
            }
            else {
                data.thumbnail = content.find("img").length
                    ? content.find("img")[0].src.trim()
                    : "";
                zfcpc.cartItems[uid] = JSON.stringify(data);
                localStorage.setItem(uid, zfcpc.cartItems[uid]);
            }
        }
        else {
            $.each(localStorage, function (key, value) {
                if (key.startsWith(uid)) {
                    localStorage.removeItem(key);
                }
            });
        }
        zfcsc.reloadCart();
    }
    static isInLocalStorage(uid) {
        var inStorage = false;
        $.each(localStorage, function (key) {
            if (key.startsWith(uid)) {
                inStorage = true;
            }
        });
        return inStorage;
    }
    static toggleCartItem(e) {
        e.preventDefault();
        var that = $(this), uid = that.closest(".zfcpc-panel").data("uid");
        that
            .toggleClass("zfcpc-cart-active")
            .find(".zfcui-icon-cart-add")
            .toggleClass("zfcui-icon-cart-remove");
        if (that.hasClass("zfcpc-cart-active") && !localStorage.getItem(uid)) {
            zfcpc.addToStorage(that);
        }
        else {
            zfcpc.removeFromStorage(that);
        }
    }
    static init(skipInitSlick) {
        try {
            if (!zfcpc.hasTargets())
                return;
            if (zfcpc.pressCardPart == undefined) {
                zfcpc.pressCardPart = zfUtils.fsData.pressCardPart;
                zfcpc.scope = zfUtils.fsData.scope;
                globalThis.zfcpc = zfcpc;
            }
            if ($(".zfcpc-load-json").length)
                zfcpc.pressCardTemplate = zfUtils.handlebarsCompile(zfcpc.pressCardPart);
            $(".zfcpc-load-json").each(function (index, item) {
                zfcpc.ajaxCount = zfcpc.ajaxCount + 1;
                zfcpc.useSwiper = $(item).hasClass("zfcpc-swiper");
                var json_url = "";
                if ($(item).data("type") != undefined)
                    json_url =
                        "/api/solr/getSearch?query=matchall&language=" +
                            document.querySelector("html").lang.toUpperCase() +
                            "&filterValues=media_type%58(" +
                            $(item).data("type") +
                            ")&scope=" +
                            zfcpc.scope +
                            "&queryType=press&size=" +
                            $(item).data("count") +
                            "&start=0";
                else if ($(item).data("ids") != undefined) {
                    var ids = $(item).data("ids");
                    if (ids.endsWith(",")) {
                        ids = ids.slice(0, -1);
                    }
                    var filterVal = "(id:" + ids.split(",").join(" OR id:") + ")";
                    filterVal = filterVal.replace(new RegExp("\\d_pressData\\."), "press_pressData.");
                    json_url =
                        "/api/solr/getSearch?query=matchall&language=" +
                            document.querySelector("html").lang.toUpperCase() +
                            "&filterValues=" +
                            filterVal +
                            "&scope=" +
                            zfcpc.scope +
                            "&queryType=press";
                }
                else
                    return;
                zfUtils.displaySpinner();
                $.ajax({
                    url: json_url,
                    dataType: "json",
                    cache: false,
                })
                    .done(function (json_data_tmp) {
                    var json_data = json_data_tmp.body;
                    var newArray = Array(json_data.hits.hit.length);
                    if ($(item).data("ids") != undefined) {
                        var indexList = $(item).data("ids").split(",");
                        indexList.pop();
                        json_data.hits.hit.forEach(function (sItem) {
                            for (let i = 0; i < indexList.length; i++) {
                                if (indexList[i].indexOf(sItem.id) != -1) {
                                    newArray[i] = sItem;
                                    return;
                                }
                            }
                        });
                    }
                    else
                        newArray = json_data.hits.hit;
                    var reducedData = {};
                    reducedData["data"] = zfcsaf.mapJsonData($(item).attr("id"), newArray, "press");
                    if ($(item).data("linktype") == "PDF")
                        reducedData.data.forEach(function (item) {
                            if (item.hasOwnProperty("meta") &&
                                item.meta.hasOwnProperty("pdf_link") &&
                                item.meta.pdf_link != "") {
                                item.mainLink = item.meta.pdf_link;
                                item.downloadLink = item.meta.pdf_link;
                                delete item.onClick;
                            }
                        });
                    if (reducedData.hasOwnProperty("data"))
                        reducedData["items"] = reducedData.data;
                    var resultHTML = zfUtils.handlebarsProcessTemplate(zfcpc.pressCardTemplate, reducedData);
                    $(item).html(resultHTML);
                    if (reducedData.data.length <= 2)
                        $(item).find(".zfcpc-wrapper").addClass("zfcpd-card-to-left");
                    $(item).removeClass("zfcpc-load-json");
                    zfUtils.hideSpinner();
                    zfcpc.ajaxCount = zfcpc.ajaxCount - 1;
                    if (zfcpc.ajaxCount == 0) {
                        zfcpc.init(false);
                    }
                })
                    .fail(function (e) {
                    window.alert("Error loading data...  status: " + e.status);
                    zfUtils.hideSpinner();
                });
            });
            if (zfcpc.ajaxCount > 0)
                return;
            var wrapper = zfcpc.useSwiper ? ".zfcpc-container" : ".zfcpc-wrapper";
            $(wrapper).each(function () {
                var that = $(this), id = that.parent().parent().parent().attr("id") + "_slider", panelCount = that.find(".zfcpc-panel").length;
                that.attr("id", id);
                if (skipInitSlick != true) {
                    that.on("init", function () {
                        $(this).show();
                    });
                    if (zfcpc.useSwiper) {
                        const swiper = new Swiper("#" + id, {
                            modules: [Navigation, Pagination, A11y],
                            spaceBetween: 24,
                            loop: false,
                            loopAddBlankSlides: false,
                            breakpoints: {
                                1024: {
                                    slidesPerView: 3,
                                    navigation: {
                                        enabled: panelCount > 3,
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                    pagination: {
                                        enabled: true,
                                        el: ".swiper-pagination",
                                        type: "bullets",
                                        clickable: true,
                                        renderBullet: function (index, className) {
                                            return ('<button type="button" class="' +
                                                className +
                                                '" aria-label="Go to slide ' +
                                                (index + 1) +
                                                '"></button>');
                                        },
                                    },
                                },
                                720: {
                                    slidesPerView: 2,
                                    navigation: {
                                        enabled: false,
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                    pagination: {
                                        enabled: true,
                                        el: ".swiper-pagination",
                                        type: "bullets",
                                        clickable: true,
                                        renderBullet: function (index, className) {
                                            return ('<button type="button" class="' +
                                                className +
                                                '" aria-label="Go to slide ' +
                                                (index + 1) +
                                                '"></button>');
                                        },
                                    },
                                },
                                0: {
                                    slidesPerView: 1,
                                    navigation: {
                                        enabled: false,
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                    pagination: {
                                        enabled: true,
                                        el: ".swiper-pagination",
                                        clickable: false,
                                        dynamicBullets: true,
                                        dynamicMainBullets: 1,
                                    },
                                },
                            },
                            a11y: {
                                enabled: true,
                                nextSlideMessage: "Next slide",
                                prevSlideMessage: "Previous slide",
                                paginationBulletMessage: "Jump to slide {{index}}",
                                slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                                slideRole: "group",
                                itemRoleDescriptionMessage: "slide",
                            },
                        });
                    }
                    else {
                        that.slick({
                            rows: 0,
                            dotsClass: "custom-dots",
                            dots: panelCount > 3,
                            swipeToSlide: true,
                            infinite: true,
                            arrows: true,
                            slidesToShow: 3,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        arrows: true,
                                        slidesToShow: 2,
                                        dots: panelCount > 2,
                                    },
                                },
                                {
                                    breakpoint: 720,
                                    settings: {
                                        arrows: false,
                                        slidesToShow: 1,
                                        dots: panelCount > 1,
                                    },
                                },
                            ],
                        });
                    }
                }
                that.find(".zfcpc-panel").each(function () {
                    var that = $(this), uid = that.data("uid");
                    if (localStorage.getItem(uid)) {
                        that
                            .find(".zfcpc-cart-button")
                            .toggleClass("zfcpc-cart-active")
                            .find(".zfcui-icon-cart-add")
                            .addClass("zfcui-icon-cart-remove");
                    }
                });
            });
            $("[data-uid]").each(function () {
                var that = $(this), uid = that.data("uid");
                if (localStorage.getItem(uid)) {
                    that.find(".zfcui-icon-cart-add").addClass("zfcui-icon-cart-remove");
                }
            });
            $(".zfcpc-cart-button").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            $(".zfcpc-cart-button")
                .off("click.zfcpc")
                .on("click.zfcpc", zfcpc.toggleCartItem);
            $(".zfcpc-download-link").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            $(".zfcpc-download-link")
                .off("click.zfcpc")
                .on("click.zfcpc", zfcpc.downloadImages);
            $(".zfcpc-panel-bottom .checkbox-element")
                .off("click.zfcpc")
                .on("click.zfcpc", zfcpc.bindCheckboxClick);
            $("[class^='zfcpd-component'] .zfcui-icon-cart-add").closest(".zfcpd-cart-collect").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            $("[class^='zfcpd-component'] .zfcui-icon-cart-add")
                .closest(".zfcpd-cart-collect")
                .off("click.zfcpc")
                .on("click.zfcpc", zfcpc.toggleCollectBtn);
        }
        catch (err) {
            console.log("Initalization failed: zfcpc.init() " + err.message);
        }
    }
}
zfcpc.scope = "press";
zfcpc.ajaxCount = 0;
zfcpc.cartItems = {};
export class zfcpd {
    static hasTargets() {
        return $(".zfcpd-readmore-trigger").length > 0;
    }
    static readMore(e) {
        $(this).hide();
        $(".zfcpd-readmore-content").css("display", "block");
    }
    static init() {
        try {
            if (!zfcpd.hasTargets())
                return;
            $(".zfcpd-readmore-trigger")
                .off("click.zfcpd")
                .on("click.zfcpd", zfcpd.readMore);
        }
        catch (err) {
            console.log("Initalization failed: zfcpd.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfcpc.init);
}
catch (err) {
    console.log("Initalization failed: zfcpc.init() " + err.message);
}
try {
    zfUtils.onReady(zfcpd.init);
}
catch (err) {
    console.log("Initalization failed: zfcpd.init() " + err.message);
}
